<script setup lang="ts">
  import {
    FormFieldContainer,
    InputField,
    SwitchButton,
    type PhoneElement,
  } from '@logistiek-zonder-papier/lzp-library'
  import FlowPathInput from '@/components/form/FlowPathInput.vue'

  const field = defineModel<PhoneElement>({ required: true })
</script>

<template>
  <div class="field-config-container">
    <FormFieldContainer label="Label">
      <FlowPathInput
        placeholder="e.g. ${customer.name}"
        hint="Field label. Supports ${...} interpolation."
        v-model="field.label"
        :optional="true"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Placeholder">
      <FlowPathInput
        placeholder="Placeholder text"
        hint="Grey hint inside the field. Supports ${...} interpolation."
        v-model="field.placeholder"
        :optional="true"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Store Location">
      <InputField
        placeholder="x.path.to.location"
        hint="Target path url."
        v-model="field.storeLocation"
        type="text"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Required">
      <SwitchButton v-model="field.required" />
    </FormFieldContainer>

    <FormFieldContainer label="Error message">
      <FlowPathInput
        placeholder="Error message under the field"
        v-model="field.error"
        :optional="true"
        :validate-paths="true"
      />
    </FormFieldContainer>
  </div>
</template>

<style scoped>
  .field-config-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .two-columns {
    display: flex;
    gap: 0.75rem;
  }

  .row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
</style>
